import type { ObjectValues } from '@/types';

export const APP_ROUTES = {
  ROOT: '/',
  AIRES_METODOLOGY: 'aires-metodology',
  AIRES_LID_STATISTICS: 'lid-statistics',
  AIRES_IMPROVE_LID: 'improve-lid',
  AIRES_LID_FORECAST: 'lid-forecast',
  LENDING_METODOLOGY: 'lending-metodology',
  COMMUNITY_METODOLOGY: 'community-metodology',
} as const;

export type AppRoutes = ObjectValues<typeof APP_ROUTES>;
